/**
 * gmx.com Parent Mailler — thin provider-bound wrapper.
 *
 * GMX (D-228) reuses the SAME admin control-plane page as mail.com. There is
 * NO copied business logic: this file only binds the shared MailcomPage stack
 * to providerId='gmx'. Every API call the page makes is therefore routed to
 * /admin/providers/gmx/* (see endpoints.ts — each function now takes a
 * providerId arg defaulting to 'mailcom'). Provider isolation is structural:
 * the page can only ever read/write the provider it was mounted with.
 *
 * RED LINE (provider isolation): this wrapper passes providerId='gmx' and
 * NOTHING else. It can never surface mail.com rows — the backend SELECTs are
 * WHERE provider_id='gmx' (generic route resolveBundle + listByProvider), and
 * the frontend never holds a mailcom path on this tree.
 *
 * Business rules (parent / 9-cap / FIFO / served-once / renewal-eligibility /
 * order-completion / dedupe) are NOT re-implemented here. They live in the
 * agnostic core (PostgresProviderAliasAllocator.atomicReserveForOrder —
 * parent-fair round-robin + per-parent created_at FIFO + alias_used_site_keys
 * served-once; RenewalEligibilityService; ProviderControlPlaneService) keyed on
 * provider_id, and GMX reuses them unchanged.
 */
import { MailcomPage } from '../mailcom/MailcomPage.js';

export function GmxPage(): JSX.Element {
  // 2026-10-23 (D-263) — the GMX ALIAS line sells again (the mail.com model;
  // D-246's passive period is over once PROVIDER_GMX_ALIAS_SALES_ENABLED /
  // PROVIDER_GMX_ALIAS_RENEWAL_ENABLED are back on). `passiveAware` stays as a
  // fail-safe: the page is read-only until the server summary confirms the line
  // is live, and shows the "pasif" banner only when the server says
  // `passive: true` (both flags off). The sidebar strike is server-driven too.
  return <MailcomPage providerId="gmx" providerLabel="gmx.com" passiveAware />;
}
